import React from 'react';

import { Form, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';

interface IComplexSwitchProps {
  value: string;
  label?: string;
  required?: boolean;
  options: ISwitchOption[];
  dataTestId?: string;
  className?: string;
  handleClick: (value: string) => void;
}

const ComplexSwitch = ({
  label,
  value,
  required,
  options,
  dataTestId,
  className,
  handleClick
}: IComplexSwitchProps) => {
  return (
    <div data-test={dataTestId ? `${dataTestId}-switch` : ''}>
      {label && (
        <Form.Label className="w-100">
          {label} {required && '*'}
        </Form.Label>
      )}
      <ToggleButtonGroup type="checkbox" size="sm" className={`z-0 ${className}`} value={[value]}>
        {options.map((option) => (
          <ToggleButton
            className="py-1 px-2"
            id={`${dataTestId}-${option.value}`}
            data-test={`${dataTestId}-${option.value}`}
            key={option.value}
            value={option.value}
            variant="outline-primary"
            onClick={() => handleClick(option.value)}
          >
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
};

export default ComplexSwitch;
